/**
 * Respawn13 — Theme bootstrap
 * Lightweight global behaviors. Section-specific JS lives in section files.
 */
(function () {
  'use strict';

  var R = window.Respawn = window.Respawn || {};

  /* -----------------------------------------------------------------------
   * Pub/sub
   * --------------------------------------------------------------------- */
  R.bus = R.bus || (function () {
    var listeners = {};
    return {
      on: function (event, fn) {
        (listeners[event] = listeners[event] || []).push(fn);
        return function off() {
          listeners[event] = (listeners[event] || []).filter(function (f) { return f !== fn; });
        };
      },
      emit: function (event, payload) {
        (listeners[event] || []).forEach(function (fn) {
          try { fn(payload); } catch (e) { /* swallow */ }
        });
      }
    };
  })();

  /* -----------------------------------------------------------------------
   * Toast
   * --------------------------------------------------------------------- */
  R.toast = function (message, opts) {
    opts = opts || {};
    var node = document.createElement('div');
    node.className = 'toast toast--' + (opts.kind || 'info');
    node.setAttribute('role', 'status');
    node.textContent = message;
    Object.assign(node.style, {
      position: 'fixed',
      right: '16px',
      bottom: '16px',
      padding: '12px 16px',
      background: 'var(--color-bg-card)',
      color: 'var(--color-text-primary)',
      border: '1px solid var(--color-accent)',
      borderRadius: '8px',
      boxShadow: 'var(--shadow-card)',
      zIndex: '1100',
      maxWidth: '320px'
    });
    document.body.appendChild(node);
    setTimeout(function () { node.remove(); }, opts.duration || 3000);
  };

  /* -----------------------------------------------------------------------
   * Focus trap helper (used by drawers/modals)
   * --------------------------------------------------------------------- */
  R.focusTrap = function (root) {
    var focusable = 'a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])';

    function onKey(e) {
      if (e.key !== 'Tab') return;
      var nodes = root.querySelectorAll(focusable);
      if (!nodes.length) return;
      var first = nodes[0];
      var last = nodes[nodes.length - 1];
      if (e.shiftKey && document.activeElement === first) {
        e.preventDefault();
        last.focus();
      } else if (!e.shiftKey && document.activeElement === last) {
        e.preventDefault();
        first.focus();
      }
    }
    root.addEventListener('keydown', onKey);
    return function release() { root.removeEventListener('keydown', onKey); };
  };

  /* -----------------------------------------------------------------------
   * Debounce
   * --------------------------------------------------------------------- */
  R.debounce = function (fn, wait) {
    var t;
    return function () {
      var args = arguments;
      var ctx = this;
      clearTimeout(t);
      t = setTimeout(function () { fn.apply(ctx, args); }, wait);
    };
  };

  /* -----------------------------------------------------------------------
   * Lazy hydrate — call once DOM is ready
   * --------------------------------------------------------------------- */
  function ready(fn) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', fn);
    } else {
      fn();
    }
  }

  ready(function () {
    R.bus.emit('theme:ready');
  });
})();
